export default {
  computed: {
    /*
    * Computed returns object with all kotlin enums
    * */
    enums() { return this.$kotlin.model.enums; },
    /*
    * Computed returns object of enumeration values.
    * And also will set correct enumeration label based on application language.
    * */
    enumsValues() {
      const locale = process.env.NODE_ENV === 'production' ? process.env.LOCALE : process.env.VUE_APP_I18N_FALLBACK_LOCALE;
      return Object.entries(this.enums)
        .reduce((accumulator, entry) => {
          const [key, value] = entry;
          /*
          * It cannot be written through rest operator,
          * because then we'll remove Kotlin enumeration type and it will be normal JS object.
          * */
          accumulator[key] = value.values().map((e) => {
            const label = e[locale];
            if (label) e.label = label;
            return e;
          });
          return accumulator;
        }, {});
    },
  },
  methods: {
    getEnumsValuesWithAppender(append) {
      const locale = process.env.NODE_ENV === 'production' ? process.env.LOCALE : process.env.VUE_APP_I18N_FALLBACK_LOCALE;
      return Object.entries(this.enums)
        .reduce((accumulator, entry) => {
          const [key, value] = entry;
          /*
          * It cannot be written through rest operator,
          * because then we'll remove Kotlin enumeration type and it will be normal JS object.
          * */
          accumulator[key] = value.values().map((e) => {
            const label = e[locale];
            const appender = `${locale}Appender`;
            const doAppend = e[appender] && append;
            if (label) e.label = doAppend ? label + e[appender] : label;
            return e;
          });
          return accumulator;
        }, {});
    },
    setEnumsLabels() {
      const locale = process.env.NODE_ENV === 'production' ? process.env.LOCALE : process.env.VUE_APP_I18N_FALLBACK_LOCALE;
      Object.entries(this.enums)
        .reduce((accumulator, entry) => {
          const [key, value] = entry;
          /*
          * It cannot be written through rest operator,
          * because then we'll remove Kotlin enumeration type and it will be normal JS object.
          * */
          accumulator[key] = value.values().map((e) => {
            const label = e[locale];
            if (label) e.label = label;
            return e;
          });
          return accumulator;
        }, {});
    },
  },
};
